<template>
    <div class="block">
        <el-button size="small" type="danger" @click="show()" :loading="loading" :disabled="this.ids.length == 0">批量解绑</el-button>

        <el-dialog
        title="温馨提示"
        :visible.sync="dialogVisible"
        width="20%"
        center>
            <div v-if="ids.length > 1" class="el-message-box__message"><p><i class="el-icon-warning" style="color: #E6A23C; font-size: 20px;"></i>&nbsp;&nbsp;确定解绑选中线索？</p></div>
            <div v-else-if="ids.length == 1" class="el-message-box__message"><p><i class="el-icon-warning" style="color: #E6A23C; font-size: 20px;"></i>&nbsp;&nbsp;确定解绑该条线索？</p></div>
            <br>
            <el-form ref="form" :model="form" :rules="rules">
                <el-form-item label="解绑原因" prop="unbind_status">
                    <el-select size="small" v-model="form.unbind_status" placeholder="请选择">
                        <el-option
                            v-for="item in unbind_types"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="submitForm('form')" :loading="loading">确 定</el-button>
            </span>
        </el-dialog>
    </div>
  </template>
  <script>
  import ClueService from "~/services/SaleClues";
  import Config from "~/config/params";
  export default {
    name: "unbindDialog",
    props: {
        ids: {
            type: Array,
            default: [],
            unbind_types: [],
        },
    },
  
    data() {
      return {
        dialogVisible: false,
        loading: false,
        form: {
            unbind_status: '',
        },
        rules: {
            unbind_status: [
                {
                    required: true,
                    message: "请选择解绑原因"
                }
            ]
        }   
      };
    },
  
    created() {
        // 查找label为'信息不属实'的元素
        const fake_info = Config.leadStatuses().find(item => item.label === '信息不属实');
        // 获取其children数组
        this.unbind_types = fake_info  ? fake_info.children : [];
    },
  
    mounted() {
  
    },
    methods: {
        show(){
            this.dialogVisible = true;
        },

        submitForm(formName) {
            this.$refs[formName].validate(valid => {
                if(valid) {
                    this.unbind();
                } else {
                    return false;
                }
            })
        },

        unbind() {
            if(this.ids.length == 0){
                this.$message.error('请先选择解绑线索！');
                return false;
            }
            this.loading = true;
            ClueService.salesmanUnbind({
                leads_ids: this.ids,
                unbind_status: this.form.unbind_status,
            }).then(res => {
                if (res.code == 0) {
                    this.$message.success('解绑成功');
                    this.$emit("change");
                    this.dialogVisible = false;
                }
                this.loading = false;
            }).catch(err => {
                console.error(err);
            })
        },
    },
  };
  </script>
  
  


// WEBPACK FOOTER //
// src/views/clue/dialog/unbindDialog.vue